import type { WeeklyPlanSite } from '../../services/scheduleService';

/**
 * Today's list in the order it should read (Jim 10/23, JIM-1023-14): the
 * visits still to do first, in the plan's order; the ones already filed sink
 * to the bottom in that same order, marked Completed rather than removed —
 * "it could be sitting in the queue, they may want to go back to it".
 */
export function orderToday<T extends Pick<WeeklyPlanSite, 'completed'>>(
  sites: T[]
): T[] {
  return [
    ...sites.filter((s) => !s.completed),
    ...sites.filter((s) => s.completed),
  ];
}

/**
 * Jim 11/2: Today's Schedule shows only what remains; the visits already
 * filed leave the list and sit folded under "Done today", still openable
 * (his 10/23 "they may want to go back to it").
 */
export function splitToday<T extends Pick<WeeklyPlanSite, 'completed'>>(
  sites: T[]
): { remaining: T[]; done: T[] } {
  return {
    remaining: sites.filter((s) => !s.completed),
    done: sites.filter((s) => s.completed),
  };
}
